import styled from "styled-components/macro";

export const LandingPageContainer = styled.div`
	position: fixed;
	top: 0px;
	left: 0px;
	z-index: 1002;
	min-width: 100%;
	min-height: 100%;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
	background-color: black;
`;
